import { render } from "./VectorLayer.vue?vue&type=template&id=01acffd2"
import script from "./VectorLayer.vue?vue&type=script&lang=js"
export * from "./VectorLayer.vue?vue&type=script&lang=js"
script.render = render

export default script